let _isLoggingOut = false;

export const setLoggingOut = (value) => {
    _isLoggingOut = value;
};

export const getIsLoggingOut = () => _isLoggingOut;
